var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"context-color",class:{'--readonly': _vm.readonly},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onClickColor.apply(null, arguments)}}},[_c('div',{staticClass:"context-color__itself --bg-accent",class:_vm.item.color})])
}
var staticRenderFns = []

export { render, staticRenderFns }